import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronDownCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 8 8",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 4,
		cy: 4,
		r: 4
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.23676 5.09684L5.76676 3.56684C5.89676 3.43684 5.89676 3.22684 5.76676 3.09684C5.63676 2.96684 5.42676 2.96684 5.29676 3.09684L4.00009 4.39017L2.70676 3.09684C2.57676 2.96684 2.36676 2.96684 2.23676 3.09684C2.10676 3.22684 2.10676 3.43684 2.23676 3.56684L3.76676 5.09684C3.89342 5.22684 4.10676 5.22684 4.23676 5.09684Z",
		fill: "white"
	})]
});
export default SvgChevronDownCircle;
